import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import BriaButtonGroup from "../BriaButtonGroup/BriaButtonGroup";
import CopyApiTokenButton from "./CopyApiTokenButton";
import styles from "./OverviewFooter.module.scss";

export type OverviewFooterProps = {
	description: string;
	primaryButton?: ReactNode;
	secondaryButton?: ReactNode;
	hideCopyTokenBtn?: boolean;
	image: string;
	className?: string;
};

const OverviewFooter = ({
	description,
	primaryButton,
	secondaryButton,
	hideCopyTokenBtn = false,
	image,
	className,
}: OverviewFooterProps) => {
	return (
		<Box className={`${styles.container} ${className}`}>
			<Box>
				<Typography className={styles.description}>{description}</Typography>
				<BriaButtonGroup className={styles.buttons}>
					{primaryButton}
					{secondaryButton}
					{!hideCopyTokenBtn && (
						<CopyApiTokenButton buttonType={primaryButton ? "secondaryMedium" : "primaryMedium"} />
					)}
				</BriaButtonGroup>
			</Box>
			<img className={styles.image} src={image} />
		</Box>
	);
};

export default observer(OverviewFooter);
